import { FC, useMemo } from "react";
import InstructorAvatar from "./InstructorAvatar";
import {
  CourseInstructor,
  instructorsDegreesTitle,
  instructorsDegreeTitlePrefix,
} from "@types";
import { ICON_SIZE, IconButton } from "@shared/components/icon-button";
import Link from "next/link";
import ArrowLeft2Icon from "@svg/new-design/arrow-left2";

interface Props {
  instructorItem: CourseInstructor;
}
const InstructureMobileCard: FC<Props> = ({ instructorItem }) => {
  const instructorName = `${
    instructorsDegreeTitlePrefix[instructorItem.instructor_caption] || ""
  } ${instructorItem.first_name} ${instructorItem.last_name}`;

  const degreeTitle = instructorsDegreesTitle[instructorItem.degree];

  const instructorDegree = useMemo(() => {
    if (instructorItem.show_special_description)
      return instructorItem.special_field;
    if (!(instructorItem.degree && instructorItem.field)) return "";
    return instructorItem.degree && degreeTitle
      ? degreeTitle + instructorItem.field
      : instructorItem.degree;
  }, [instructorItem]);

  return (
    <div className="relative rounded-12 items-center course-instructure-section py-5 px-4 flex gap-2.5 ">
      <InstructorAvatar instructorItem={instructorItem} />
      <div className="flex flex-col gap-1.6">
        <p className="title-md-demibold line-clamp-1">{instructorName}</p>
        <p className="title-sm text-fds-secondary">{instructorDegree}</p>
      </div>
      <Link href={`/instructors/${instructorItem.slug}`} target="_blank">
        <IconButton
          icon={<ArrowLeft2Icon />}
          size={ICON_SIZE.SMALL}
          className="absolute left-0.5 bottom-2"
          iconClassName="text-fds-icon-brand h-4 w-4"
          aria-label="مشاهده صفحه مدرس"
        />
      </Link>
    </div>
  );
};

export default InstructureMobileCard;
